module.exports = __webpack_public_path__ + "static/media/cargando.106af94f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cargando.gif
// module id = 993
// module chunks = 0